import type { CurrencyLocale } from '@/i18n/models';
import { datetimeFormats } from '@/i18n/dates/DateFormats';
import en from './locales/en-EN.json';
import type { I18nOptions } from 'vue-i18n';
import { Locale } from '@/i18n/models';
import nl from './locales/nl-NL.json';
import { numberFormats } from '@/i18n/numbers/NumberFormats';

// TODO (S.Panfilov) type mismatch with "createI18n"
export const i18nOptions: I18nOptions = {
  // export const i18nOptions = {
  legacy: false,
  locale: process.env.VUE_APP_I18N_LOCALE || Locale.NL,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || Locale.EN,
  messages: {
    [Locale.NL]: nl,
    [Locale.EN]: en
  },
  numberFormats: numberFormats,
  datetimeFormats: datetimeFormats
};

export type MessageSchema = typeof nl | typeof en;

export type NumberSchema = typeof numberFormats[CurrencyLocale.NL] | typeof numberFormats[CurrencyLocale.EN];
